// Карточка результата по его типу. SMY-114
//
// ТАБЛИЦЕЙ на все типы сразу, а не цепочкой `if`. `Record<ArtifactType, …>`
// здесь несущий: он не даст собрать кабинет, пока у нового типа артефакта нет
// карточки. Прежняя цепочка молчала о пропущенных, и молчала она ровно про
// два — `search` и `doc_create`. За каждый результат списана единица, и тип
// без экрана значит списание без результата (SMY-111). Такое нельзя ловить
// на проде.
//
// Карточки поиска здесь больше нет: 06.09.2026 результатом веб-поиска стал
// обычный ответ в ленте, а не то, что уносят с собой (см. ARTIFACT_TYPES).

import type { ReactElement } from 'react'
import type { ArtifactType } from '@smyslika/core'

import { DocDraftCard } from './DocDraft.tsx'
import { DocReviewCard } from './DocReview.tsx'
import { ImageCard } from './Image.tsx'
import type { CardProps } from './common.tsx'

export type { CardProps, ResultMeta } from './common.tsx'

const CARDS: Record<ArtifactType, (p: CardProps) => ReactElement> = {
  doc_review: DocReviewCard,
  doc_create: DocDraftCard,
  image: ImageCard,
}

export function ResultCard(props: CardProps) {
  const Card = CARDS[props.artifact.type]
  // Тип приходит с сервера строкой, и таблица его может не знать: типы ядра
  // покрыты все, но чужое значение всё равно возможно. Номер задачи в таком
  // тексте не называем — задача закроется, а строка останется и будет врать,
  // как случилось с прежней заглушкой.
  if (Card == null) {
    return (
      <p className="muted">
        Результат готов, но показать его этой карточкой я не умею. Он не потерян — открывается из истории.
      </p>
    )
  }
  return <Card {...props} />
}
